// @ts-nocheck
export async function waitingTimer(delay: number): Promise<void> {
	return new Promise<void>((resolve) => setTimeout(() => resolve(), delay));
}
